var _path, _rect, _path2, _path3, _path4, _path5, _path6, _circle, _line, _line2, _line3, _circle2, _path7, _circle3, _circle4, _circle5, _line4, _circle6, _circle7, _circle8, _circle9, _polygon, _path8, _polygon2, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle10, _path17, _path18, _ellipse, _circle11, _path19, _circle12, _line5, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStyle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bc9239de-9137-4d49-9033-46cbd1d50d93",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 974.68253,
    height: 719.80711,
    viewBox: "0 0 974.68253 719.80711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coolness") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M610.20152,103.04319,347.09922,245.5543a66.93013,66.93013,0,1,1-117.65045,63.72619l-89.71039,48.59223L372.116,786.88529,842.57908,532.05582Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 287.65873,
    y: 471.52291,
    width: 50,
    height: 50,
    transform: "translate(26.07928 -153.4681) rotate(14.95654)",
    fill: "#ff8533",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M410.60736,673.21219c-38.61324,59.2152-28.03318,134.52933-28.03318,134.52933s73.18448-20.69269,111.79771-79.90789S522.40507,593.3043,522.40507,593.3043,449.22059,613.997,410.60736,673.21219Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M382.36876,807.05287s-.94-.15-2.67005-.5c-1.38-.28-3.28-.68-5.6-1.23-20.74-4.89-75.88-21.42-111.93-64.88-45.12-54.42-43.22-130.45-43.22-130.45s68.99005,11.21,114.45,60.08q2.95506,3.15,5.75,6.53c39.26,47.35,42.92,111.06006,43.21,126.81006C382.39872,805.77291,382.36876,807.05287,382.36876,807.05287Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#ff8533"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M354.541,673.21219c38.61324,59.2152,28.03318,134.52933,28.03318,134.52933s-73.18448-20.69269-111.79772-79.90789S242.74329,593.3043,242.74329,593.3043,315.92777,613.997,354.541,673.21219Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M382.35875,803.41292c-1.02,1.23-1.92,2.28-2.66,3.13995-1.63995,1.87-2.57,2.85-2.57,2.85s-1.12994-1.42-3.03-4.08c-10.43-14.54-43.98-66.24-41.39-125.96q.21-4.695.69-9.29,2.95506,3.15,5.75,6.53C378.40873,723.9529,382.06871,787.66292,382.35875,803.41292Z",
    transform: "translate(-112.65873 -89.59645)",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M439.61211,683.68161c-3.05208,70.62654-55.47967,125.72194-55.47967,125.72194s-47.47917-59.41282-44.42708-130.03935S395.185,553.64226,395.185,553.64226,442.6642,613.05508,439.61211,683.68161Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#ff8533"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.45841,
    cy: 610.6557,
    r: 6.53537,
    fill: "#ae8eb4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 163,
    y1: 717.92646,
    x2: 436,
    y2: 717.92646,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 717.92646,
    x2: 129,
    y2: 717.92646,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 65.47719,
    y1: 719.12821,
    x2: 65.47719,
    y2: 644.71684,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.47719,
    cy: 644.71684,
    r: 10.52282,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.13592,780.17455s-1.50326-32.33193-32.32009-28.57378",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.75,
    cy: 427.31419,
    r: 20.28889,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.11667,
    cy: 427.31419,
    r: 14.75556,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.38333,
    cy: 427.31419,
    r: 14.75556,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 271.47371,
    y1: 717.80711,
    x2: 283,
    y2: 466.92646,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 914.25,
    cy: 271.75556,
    r: 20.28889,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.61667,
    cy: 15.75556,
    r: 14.75556,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.88333,
    cy: 107.75556,
    r: 14.75556,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.98759,
    cy: 129.13204,
    r: 47.76284,
    fill: "#ae8eb4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "764.924 551.174 790.453 654.112 815.981 649.994 790.453 532.234 764.924 551.174",
    fill: "#996633"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M912.17009,737.12s-14.53836,4.91525-12.62191,8.2221,1.91644,23.89429-4.67154,31.30576-23.05792,30.4694-4.11748,31.2929S928.64,796.4118,928.64,796.4118V775.00087l3.294,19.76393h3.294V772.53038s8.235-13.99945,3.294-22.23443-8.16167-15.41149-14.37455-14.70547S912.17009,737.12,912.17009,737.12Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#333"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "664.458 638.465 660.34 660.7 689.163 660.7 689.163 638.465 664.458 638.465",
    fill: "#996633"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M779.587,745.355s-8.235-.8235-10.70546,10.70546-24.70492,35.99891-32.93989,38.4694-8.235,10.70547,2.47049,12.35246,37.88087,2.47049,44.46885-6.588,15.64645-23.64645,15.64645-23.64645L794.41,807.70579h7.41148s6.588-30.23443,13.17595-37.6459S801.82146,745.355,798.52747,745.355Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M739.23567,391.25115s-5.76449,15.64645-15.64645,18.11694S640.416,429.132,640.416,429.132s-64.23279,1.647-44.46886,15.64645,51.88033,0,51.88033,0,93.87869-11.529,101.29016-23.88142a166.4606,166.4606,0,0,0,12.35246-26.35192Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#996633"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M770.52856,322.07739s-46.93934,76.58524-41.17486,78.23223,59.2918,18.94044,61.76229,12.35246,2.47049-37.05737,2.47049-37.05737Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M770.52856,322.07739s-46.93934,76.58524-41.17486,78.23223,59.2918,18.94044,61.76229,12.35246,2.47049-37.05737,2.47049-37.05737Z",
    transform: "translate(-112.65873 -89.59645)",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M892.40615,303.96045,998.6373,358.31126s60.1153,15.64645,46.93934,27.99891-55.99781-10.70546-55.99781-10.70546L871.81872,322.07739Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#996633"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M756.52911,261.13859s20.58743,31.2929,18.94043,38.70437c0,0,1.647,4.941-.82349,8.235s-1.647,23.05793-1.647,23.05793l8.235,11.529,10.70547-35.41038,4.941-37.88088s-11.11721-15.2347-9.47022-22.64617S756.52911,261.13859,756.52911,261.13859Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#996633"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M821.58539,439.014S775.46954,562.53858,775.46954,616.8894,758.1761,733.00251,771.35206,738.767s79.87923,6.588,81.52623,0-8.235-274.22458-13.176-284.93S821.58539,439.014,821.58539,439.014Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M821.58539,439.014S775.46954,562.53858,775.46954,616.8894,758.1761,733.00251,771.35206,738.767s79.87923,6.588,81.52623,0-8.235-274.22458-13.176-284.93S821.58539,439.014,821.58539,439.014Z",
    transform: "translate(-112.65873 -89.59645)",
    opacity: 0.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 654.57584,
    cy: 146.01373,
    r: 30.4694,
    fill: "#996633"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M776.293,327.84187l-2.20523-18.58441s-6.85324,9.52594-6.85324,16.93741-4.11748,33.76339,13.176,50.23333,20.58743,19.76394,21.41093,23.05793,4.941,3.294,4.941,3.294l23.88142,96.34917s7.41147,256.10765,18.94044,259.40164,46.93934,0,49.40983-4.11749-4.11749-113.64262-4.11749-113.64262,18.11694,97.17267,24.70492,97.17267S930.287,723.944,928.64,723.12054s-11.529-64.23278-15.64645-83.99671S910.52309,452.19,910.52309,452.19s13.176-21.41093-32.11639-63.40929c0,0-28.8224-83.99672-30.4694-83.99672s-33.76339-45.29234-33.76339-45.29234-18.11693,0-21.41092,10.70546S776.293,327.84187,776.293,327.84187Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M804.292,266.07957l9.882-6.588s41.17487,24.70491,69.99727,26.35191,27.99891,18.11694,16.46995,29.6459-56.82131,51.05683-58.46831,41.17486S804.292,266.07957,804.292,266.07957Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.98759,
    cy: 115.95608,
    rx: 32.93989,
    ry: 19.76393,
    fill: "#ae8eb4"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 658.28158,
    cy: 81.3692,
    r: 19.76393,
    fill: "#ae8eb4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M744.5884,160.26018a19.766,19.766,0,0,1,17.70519-19.65708,19.98481,19.98481,0,0,0-2.05874-.10686,19.76393,19.76393,0,1,0,0,39.52787,19.982,19.982,0,0,0,2.05874-.10686A19.766,19.766,0,0,1,744.5884,160.26018Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#ae8eb4"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.56418,
    cy: 189.56907,
    r: 54.31516,
    fill: "#ff8533"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 495.5,
    y1: 718.36783,
    x2: 887.5,
    y2: 718.36783,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.15168,263.5454l-47.47823,47.47831-19.95531-19.95552a6.82149,6.82149,0,0,0-9.64706,0l-.71689-1.07225c-2.664,2.664-1.94711,8.05537.71686,10.71934l25.8918,25.89174a5.2049,5.2049,0,0,0,7.35891.00191l53.47207-53.41632c2.6657-2.66291,3.63268-7.546.96834-10.21022h0C1083.09887,260.31911,1077.815,260.88212,1075.15168,263.5454Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#ff8533"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.15168,263.5454l-47.47823,47.47831-19.95531-19.95552a6.82149,6.82149,0,0,0-9.64706,0l-.71689-1.07225c-2.664,2.664-1.94711,8.05537.71686,10.71934l25.8918,25.89174a5.2049,5.2049,0,0,0,7.35891.00191l53.47207-53.41632c2.6657-2.66291,3.63268-7.546.96834-10.21022h0C1083.09887,260.31911,1077.815,260.88212,1075.15168,263.5454Z",
    transform: "translate(-112.65873 -89.59645)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.15168,261.44044l-47.47823,47.47831-19.95531-19.95551a6.8215,6.8215,0,0,0-9.64706,0h0a6.82151,6.82151,0,0,0,0,9.64709l25.8918,25.89173a5.20489,5.20489,0,0,0,7.35891.00192l53.47207-53.41632a6.8198,6.8198,0,0,0,.00246-9.64723h0A6.81981,6.81981,0,0,0,1075.15168,261.44044Z",
    transform: "translate(-112.65873 -89.59645)",
    fill: "#ff8533"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle);
export default __webpack_public_path__ + "static/media/style.4c266f5499bd05d78d8d25416c21835d.svg";
export { ForwardRef as ReactComponent };